import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


import { isEqual } from "lodash";

import {hasProperty, formatText, formatDate} from '../utils/utils';
import {cloneObject, getParam, truncate} from '../utils/utils';

import D3Graphviz from "../components/D3Graphviz";


import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewLogicalModel from "../components/ViewLogicalModel";
import ViewEntity from "../components/ViewEntity";
import ViewRelationship from "../components/ViewRelationship";
import Buffering from "../components/Buffering";


import { getLogicalModelVersion, getLogicalModelVersionEntities, zipLogicalModel } from "../utils/utilsLogicalModel";


class ViewLogicalModelVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };


        this.handleControls = this.handleControls.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleExport = this.handleExport.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

        this.setup();
 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props.params, prevProps.params)){
            this.setup();
        }

        let StateChange = {};

        if (!isEqual(this.state, prevState)){

            if (this.state.loadData){
                this.loadData(this.state.idLogicalModel, this.state.idVersion);
                StateChange.loadData = false;
            }

            if (this.state.isLoaded && this.state.LogicalModel && this.state.idLogicalModel && this.state.idVersion){
                // Fetch CSV from server
                if (this.state.LogicalModel !== prevState.LogicalModel){
                    const onLoadCsv = (csv) => {
                        this.setState({csv: csv});
                    };

                    const onFailCsv = (e) => {
                        console.error('Error fetching CSV:', e);
                    };

                    getLogicalModelVersion(
                        this.dsd,
                        this.state.idLogicalModel,
                        this.state.idVersion,
                        onLoadCsv,
                        onFailCsv,
                        'csv'
                    );

                    const onLoadXsd = (xsds) => {
                        this.setState({xsds: xsds});
                    };

                    const onFailXsd = (e) => {
                        console.error('Error fetching XSD:', e);
                    };

                    getLogicalModelVersion(
                        this.dsd,
                        this.state.idLogicalModel,
                        this.state.idVersion,
                        onLoadXsd,
                        onFailXsd,
                        'xsd'
                    );


                    const onLoadDot = (dot) => {
                        this.setState({dot: dot});
                    };

                    const onFailDot = (e) => {
                        console.error('Error fetching DOT:', e);
                    };

                    getLogicalModelVersion(
                        this.dsd,
                        this.state.idLogicalModel,
                        this.state.idVersion,
                        onLoadDot,
                        onFailDot,
                        'dot',
                        null,
                        {vizStructures: false}
                    );


                    const onLoadEntitiesDot = (dots) => {
                        this.setState({dotEntities: dots});
                    };

                    const onFailEntitiesDot = (e) => {
                        console.error('Error fetching DOT:', e);
                    };

                    getLogicalModelVersionEntities(
                        this.dsd,
                        this.state.idLogicalModel,
                        this.state.idVersion,
                        onLoadEntitiesDot,
                        onFailEntitiesDot,
                        'dot',
                        null,
                        {vizStructures: true}
                    );


                }
            }

            this.setState(StateChange);
        }

     }



    setup(){

        let StateChange = {
            idVersion: null,
            idLogicalModel: null,
            type: null,
            LogicalModel: null,
            isLoaded: false,
            isFailed: false, 
            loadData: false,

            Controls: {
            },

            csv: null,
            xsds: null,
            dot: null,
            dotEntities: null

        }

        StateChange.idVersion = getParam('idVersion', this.props);
        if (StateChange.idVersion){
            StateChange.loadData = true;
        }

        StateChange.idLogicalModel = getParam('idLogicalModel', this.props);
        if (StateChange.idLogicalModel){
            StateChange.loadData = true;
        }

        StateChange.isExporting = false;
        this.setState(StateChange);

    }

    loadData(id, idVersion){

        const onLoad = function(data){
            let StateChange = {};
            StateChange.LogicalModel = data;
            StateChange.isLoaded = true;
            this.setState(StateChange);
            return;
        }.bind(this);

        var onFail = function(e){
            let StateChange = {};
            StateChange.LogicalModel = null;
            StateChange.isFailed = true;

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);


        if (id){
            getLogicalModelVersion(this.dsd, id, idVersion, onLoad, onFail);
        }

        return;
    }

    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let LogicalModel = cloneObject(this.state.LogicalModel); 
            let Version = LogicalModel.Version;
            let idLogicalModel = this.state.idLogicalModel;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipLogicalModel(this.dsd, LogicalModel);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `logicalmodel_${idLogicalModel}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }

    render() {

        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.isLoaded){
            return(
                <div>
                    <PD.Heading>{`Logical Model: ${this.state.LogicalModel.name}`}</PD.Heading>
                    {this.state.LogicalModel.Version &&
                        <>
                           {this.viewVersion(this.state.LogicalModel.Version)}
                        </>
                    }
                    {this.viewLogicalModel(this.state.LogicalModel)}
                </div>
            )
        }
        return null;

    };    

    viewVersion(Version){

        if (Version){
            return(
                <fieldset>
                    <legend>Named Version</legend>
                    <PD.Table className="panel">
                        <PD.Tbody>                                

                            {hasProperty(Version,'name') &&
                                <PD.Tr>                                
                                    <PD.Th>Name</PD.Th><PD.Td>{Version.name}</PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'description') &&
                                <PD.Tr>
                                    <PD.Th>Description</PD.Th>
                                    <PD.Td>
                                        <PD.MdPresent>
                                            {Version.description}
                                        </PD.MdPresent>                                    
                                    </PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'createdAt') &&
                                <PD.Tr>
                                    <PD.Th>Date/Time</PD.Th><PD.Td>{formatDate(Version.createdAt,'dmy hms')}</PD.Td>
                                </PD.Tr>
                            }

                        </PD.Tbody>
                    </PD.Table>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                </fieldset>
                
            )
        };
        return null;
    };

    viewLogicalModel(LogicalModel){
        if (LogicalModel){

            let countEntities = 0;
            if (LogicalModel.Entities){
                if (LogicalModel.Entities.length){
                    countEntities = LogicalModel.Entities.length;
                }
            }

            let countRelationships = 0;
            if (LogicalModel.Relationships){
                if (LogicalModel.Relationships.length){
                    countRelationships = LogicalModel.Relationships.length;
                }
            }


            return(
                <div>
                    <ViewLogicalModel LogicalModel={LogicalModel} noLinks/>

                    <fieldset>
                        <legend>visualisation</legend>
                        <D3Graphviz dot={this.state.dot} onClick={this.handleNavClick}/>
                    </fieldset>

                    <PD.Heading level="2">Index</PD.Heading>
                    {countEntities &&
                        <fieldset>
                            <legend>Entities</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        LogicalModel.Entities.map(
                                            (Entity, pos) => 
                                            {
                                                switch (Entity.status){
                                                    case 'deprecated': return null;
                                                    default:
                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#entity_${Entity._id}`} onClick={this.handleNavClick}>{Entity.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Entity.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>

                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }



                    {countRelationships &&
                        <fieldset>
                            <legend>Relationships</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>                            
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        LogicalModel.Relationships.map(
                                            (Relationship, pos) => 
                                            {                                                
                                                switch (Relationship.status){
                                                    case 'deprecated': return null;
                                                    default:
                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#relationship_${Relationship._id}`} onClick={this.handleNavClick}>{Relationship.label}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Relationship.description, 400)}</PD.MdPresent>
                                                                </PD.Td>

                                                            </PD.Tr>

                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    <fieldset>
                        <legend>Renditions</legend>
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Type</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>
                            <PD.Tbody>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_csv`} onClick={this.handleNavClick}>CSV</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_rdfs`} onClick={this.handleNavClick}>RDF Schema</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_xsd`} onClick={this.handleNavClick}>XSD Schema</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_dot`} onClick={this.handleNavClick}>DOT</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>

                            </PD.Tbody>
                        </PD.Table>
                    </fieldset>


                    {
                        countEntities &&
                            <div>
                                <PD.Heading level="2">Entities</PD.Heading>
                                {
                                    LogicalModel.Entities.map(
                                        (Entity, pos) => 
                                        {
                                            switch (Entity.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset id={`entity_${Entity._id}`}>
                                                            <ViewEntity key={pos} Entity={Entity} noLinks/>

                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <D3Graphviz dot={this.state.dotEntities && this.state.dotEntities[Entity._id]} onClick={this.handleNavClick}/>
                                                            </fieldset>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }


                    {
                        countRelationships &&
                            <div>
                                <PD.Heading level="2">Relationships</PD.Heading>
                                {
                                    LogicalModel.Relationships.map(
                                        (Relationship, pos) => 
                                        {        
                                            switch (Relationship.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset id={`relationship_${Relationship._id}`}>
                                                            <ViewRelationship key={pos} Relationship={Relationship} noLinks/>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }

                    <PD.Heading level="2">Renditions</PD.Heading>
                    {this.viewCSV(this.state.csv)}
                    {this.viewRDFS(LogicalModel._id)}
                    {this.viewXSDs(this.state.xsds)}
                    {this.viewDOT(this.state.dot)}
                </div>
            )
        }
    }

    viewCSV(csv){

        return(
            <fieldset id={`rendition_csv`}>
                <legend>CSV</legend>
                <pre>
                    {csv}   
                </pre>
            </fieldset>
        )
    }

    viewDOT(dot){

        return(
            <fieldset id={`rendition_dot`}>
                <legend>DOT</legend>
                <pre>
                    {dot}   
                </pre>
            </fieldset>
        )
    }



    viewRDFS(idLogicalModel){

        return(
            <fieldset id={`rendition_rdfs`}>
                <legend>rdf schema</legend>
                <ViewLogicalModelRdfs dsd={this.dsd} idLogicalModel={idLogicalModel} idVersion={this.state.idVersion}/>
            </fieldset>
        )
    }

    viewXSDs(xsds = {}){

        return(
            <fieldset id={`rendition_xsd`}>
                <legend>XML Schema</legend>
                <pre>
                    {
                        xsds && Object.keys(xsds).map(
                        (filename, pos) => 
                            {
                                return (
                                    <>
                                        {filename}{"\n"}{xsds[filename]}{"\n\n"}
                                    </>
                                )
                            }
                        )
                    }

                </pre>
            </fieldset>
        )
    }
 
};

class ViewLogicalModelRdfs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idLogicalModel: null,
            isLoaded: false,
            isFailed: false, 
            RDFS: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idLogicalModel = getParam('idLogicalModel', this.props);

        if (StateChange.idLogicalModel){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.RDFS = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.RDFS = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getLogicalModelVersion(dsd,StateChange.idLogicalModel,StateChange.idVersion, onLoad, onFail,'rdfs')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {this.state.RDFS}
                </pre>
            )
        }
        return <div/>
    }

};
        
export default function ViewLogicalModelVersion_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewLogicalModelVersion {...props} navigation={navigation} location={location} params={params} />;
  }
